module.exports = __webpack_public_path__ + "static/img/fuwu.c84bfe95.jpg";